/**
 * Libellés alignés backend collectContractSendGateMissing / assertSignatoryReady.
 */
export const NR2J_CONTRACT_SEND_GATE_LABELS = Object.freeze({
  'raisonSociale|nomCommercial': 'Identité de la société (raison sociale ou nom commercial)',
  adresse: 'Adresse de la société',
  codePostal: 'Code postal de la société',
  ville: 'Ville de la société',
  pays: 'Pays de la société',
  siren: 'SIREN de la société',
  'siren|siret|tvaIntracommunautaire': 'Identifiant légal de la société (SIREN, SIRET ou TVA)',
  initialDurationMonths: 'Durée initiale du contrat',
  renewalMode: 'Mode de reconduction',
  renewalDurationMonths: 'Durée de reconduction tacite',
  noticePeriodMonths: 'Préavis (mois)',
  signatoryName: 'Nom du signataire',
  signatoryEmail: 'Email du signataire',
  signatoryFunction: 'Fonction du signataire',
  templateVersionId: 'Modèle de contrat publié',
  lines: 'Ligne(s) dans l’offre contractuelle',
});

const SIGNATORY_GATE_KEYS = new Set([
  'signatoryName',
  'signatoryEmail',
  'signatoryFunction',
]);

export function contractSendGateLabel(key) {
  return NR2J_CONTRACT_SEND_GATE_LABELS[key] || key;
}

export function extractNr2jContractGateMissing(error) {
  const raw = error?.data?.error?.missing
    || error?.response?.data?.error?.missing
    || error?.missing;
  return Array.isArray(raw) ? raw.filter(Boolean) : [];
}

export function formatNr2jContractGateMissingList(missingKeys = []) {
  const keys = (missingKeys || []).filter(Boolean);
  if (!keys.length) return '';
  const labels = keys.map((k) => contractSendGateLabel(k));
  if (labels.length === 1) {
    const label = labels[0];
    if (SIGNATORY_GATE_KEYS.has(keys[0])) {
      return `${label} manquante`;
    }
    return `${label} — à compléter`;
  }
  return `Informations à compléter avant envoi : ${labels.map((l) => l.toLowerCase()).join(' · ')}`;
}

export function formatNr2jContractGateError(error, fallback = 'Action impossible') {
  const code = error?.data?.error?.code || error?.response?.data?.error?.code;
  const missing = extractNr2jContractGateMissing(error);
  if ((code === 'CONTRACT_SEND_GATE' || missing.length) && missing.length) {
    const formatted = formatNr2jContractGateMissingList(missing);
    if (formatted) return formatted;
  }
  const msg = error?.message || error?.data?.error?.message || error?.response?.data?.error?.message;
  return msg || fallback;
}
